import React, { useEffect, useState, useCallback } from 'react';

const SCROLL_THRESHOLD = 1200;

const VogueHero = () => {
  const [scrollY, setScrollY] = useState(0);

  const handleScroll = useCallback(() => {
    setScrollY(window.scrollY);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const progress = Math.min(scrollY / SCROLL_THRESHOLD, 1);
  
  const leftOffset = -400 + (progress * 400);
  const rightOffset = 400 - (progress * 400);

  return (
    <section className="min-h-screen bg-white flex items-center justify-center relative overflow-hidden">
      <div className="relative w-full flex flex-col items-center justify-center" style={{ height: '90vh' }}>
        
        <div className="text-center mb-12">
          <h2 className="text-6xl md:text-8xl font-bold tracking-tighter" style={{ fontFamily: 'Archivo, sans-serif' }}>
            JANA JANKE
          </h2>
          <p className="text-sm tracking-widest mt-4 text-gray-600" style={{ fontFamily: 'Archivo, sans-serif' }}>
            BRAND & GRAPHIC DESIGNER
          </p>
        </div>

        <div className="my-8 animate-bounce">
          <div className="w-px h-16 bg-black"></div>
        </div>

        <div className="relative w-full flex items-center justify-center mt-8" style={{ minHeight: '120px' }}>
          <h1
            className="absolute text-4xl md:text-6xl text-black whitespace-nowrap font-light tracking-wider"
            style={{
              fontFamily: 'Archivo, sans-serif',
              left: '50%',
              transform: `translateX(calc(-100% - 20px + ${leftOffset}px))`,
              letterSpacing: '0.05em'
            }}
          >
            design with fire
          </h1>

          <h1
            className="absolute text-4xl md:text-6xl text-black whitespace-nowrap font-light tracking-wider"
            style={{
              fontFamily: 'Archivo, sans-serif',
              left: '50%',
              transform: `translateX(calc(20px + ${rightOffset}px))`,
              letterSpacing: '0.05em'
            }}
          >
            create with purpose
          </h1>
        </div>

      </div>
    </section>
  );
};

export default VogueHero;